export enum CourseStatus {
    DA_NHAN_FORM = 'ĐÃ NHẬN FORM',
    DANG_TIM_GV = 'ĐANG TÌM GV',
    DANG_HOC = 'ĐANG HỌC',
    CHUYEN_LOP = 'CHUYỂN LỚP',
    XONG = 'XONG',
    HUY = 'HUỶ',
    BAO_LUU = 'BẢO LƯU',
    PENDING = 'PENDING',
}

export const COURSE_STATUS_CONFIG = {
    [CourseStatus.DA_NHAN_FORM]: {
        label: 'Đã nhận form',
        cssClass: 'text-sm !bg-gray-100 !text-gray-700'
    },
    [CourseStatus.DANG_TIM_GV]: {
        label: 'Đang tìm GV',
        cssClass: 'text-sm !bg-yellow-100 !text-yellow-700'
    },
    [CourseStatus.DANG_HOC]: {
        label: 'Đang học',
        cssClass: 'text-sm !bg-blue-100 !text-blue-700'
    },
    [CourseStatus.CHUYEN_LOP]: {
        label: 'Chuyển lớp',
        cssClass: 'text-sm !bg-orange-100 !text-orange-700'
    },
    [CourseStatus.XONG]: {
        label: 'Xong',
        cssClass: 'text-sm !bg-green-100 !text-green-700'
    },
    [CourseStatus.HUY]: {
        label: 'Huỷ',
        cssClass: 'text-sm !bg-red-100 !text-red-700'
    },
    [CourseStatus.BAO_LUU]: {
        label: 'Bảo lưu',
        cssClass: 'text-sm !bg-purple-100 !text-purple-700'
    },
    [CourseStatus.PENDING]: {
        label: 'Pending',
        cssClass: 'text-sm !bg-gray-200 !text-gray-600'
    }
};
